import { Card, CardContent } from "@/components/ui/card"
import { categories } from "../-data/fixtures"

export default function TopPrescribedMedications() {
  return (
    <Card className="rounded-2xl">
      <CardContent className="p-4">
        <div className="text-xs text-muted-foreground">Top Prescribed Medications</div>
        <div className="mt-2 space-y-2">
          {categories.topPrescribed.map((c, i) => (
            <div key={i} className="flex items-center justify-between text-sm">
              <span>{c.label}</span>
              <div className="flex items-center gap-2">
                <span className="tabular-nums">AED {c.value.toFixed(2)}</span>
                <span className={`${c.deltaPct >= 0 ? "text-green-600" : "text-red-600"} text-xs`}>
                  {c.deltaPct >= 0 ? "↗" : "↘"} {Math.abs(c.deltaPct)}%
                </span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}